import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ConsultantChatGate from '../components/ConsultantChatGate';
import HowItWorks from '../components/HowItWorks';
import AboutUsSection from '../components/AboutUsSection';
import TaskCTA from '../components/TaskCTA';
import RequestCalculationForm from '../components/RequestCalculationForm';
import InvoiceStepsSection from '../components/InvoiceStepsSection';
import NewsSection from '../components/NewsSection';
import SEOHead from '../components/SEOHead';
import HomepageLeadDialog from '../components/homepage-draft/HomepageLeadDialog';
import {
  HomepageDraftCatalog,
  HomepageDraftHero,
  HomepageDraftSolutions,
  HomepageDraftTasks,
} from '../components/homepage-draft/HomepageDraftSections';
import { HOMEPAGE_DRAFT_SEO } from '../data/homepageDraft';
import { trackFreeConsultationClick } from '../lib/metrikaGoals';

const HomepageDraftPage = () => {
  const [lead, setLead] = useState({
    open: false,
    source: 'hero',
    task: '',
    nonce: 0,
  });
  const [isCalculationFormOpen, setIsCalculationFormOpen] = useState(false);

  const openLead = (source, task = '') => {
    setLead((prev) => ({
      open: true,
      source,
      task,
      nonce: prev.nonce + 1,
    }));
  };

  const openConsultation = () => {
    trackFreeConsultationClick();
    setIsCalculationFormOpen(true);
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <SEOHead
        title={HOMEPAGE_DRAFT_SEO.title}
        description={HOMEPAGE_DRAFT_SEO.description}
        noindex
      />
      <Header onContactClick={() => openLead('header')} />
      <main className="flex-1 pt-16">
        <HomepageDraftHero onOpen={openLead} />
        <HomepageDraftCatalog />
        <HomepageDraftTasks onOpenTask={(task) => openLead('task', task)} />
        <HomepageDraftSolutions onOpenSolution={(name) => openLead('solution', name)} />
        <HowItWorks onConsultationClick={openConsultation} />
        <InvoiceStepsSection />
        <AboutUsSection
          showTitle={false}
          showInfoCards={false}
          sectionHeading="Преимущества"
          hideAdvantagesHeading
        />
        <TaskCTA
          title="Обратный звонок"
          onCalculationClick={() => openLead('callback')}
          showRequestButton={false}
        />
        <NewsSection />
      </main>
      <Footer />
      <ConsultantChatGate />
      <HomepageLeadDialog
        open={lead.open}
        onOpenChange={(open) => setLead((prev) => ({ ...prev, open }))}
        source={lead.source}
        presetTask={lead.task}
        nonce={lead.nonce}
      />
      <RequestCalculationForm
        open={isCalculationFormOpen}
        onOpenChange={setIsCalculationFormOpen}
        calculatorData={null}
      />
    </div>
  );
};

export default HomepageDraftPage;
